import http from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'
import { REPORTS_INIT_LOADING, REPORTS_INIT_SUCCESS, REPORTS_INIT_FAIL, REPORTS_AGENCY_INIT_LOADING, REPORTS_AGENCY_INIT_SUCCESS, REPORTS_AGENCY_INIT_FAIL, REPORTS_HISTORY_UPDATE, REPORTS_HISTORY_FAVOURITE_UPDATE,
  REPORTS_HISTORY_INIT_LOADING, REPORTS_HISTORY_INIT_SUCCESS, REPORTS_HISTORY_INIT_FAIL, REPORTS_HISTORY_FAVOURITE_INIT_LOADING, REPORTS_HISTORY_FAVOURITE_INIT_SUCCESS, REPORTS_HISTORY_FAVOURITE_INIT_FAIL,
  REPORTS_HISTORY_LOADMORE_LOADING, REPORTS_HISTORY_LOADMORE_SUCCESS, REPORTS_HISTORY_LOADMORE_FAIL
  , REPORTS_FIRESCHEDULE_INIT_LOADING, REPORTS_FIRESCHEDULE_INIT_SUCCESS, REPORTS_FIRESCHEDULE_INIT_FAIL, REPORTS_UW_INIT_LOADING, REPORTS_UW_INIT_SUCCESS, REPORTS_UW_INIT_FAIL, REPORTS_RI_INIT_LOADING, REPORTS_RI_INIT_SUCCESS, REPORTS_RI_INIT_FAIL
  , REPORTS_CLAIM_INIT_LOADING, REPORTS_CLAIM_INIT_SUCCESS, REPORTS_CLAIM_INIT_FAIL
  , REPORTS_ACCT_INIT_LOADING, REPORTS_ACCT_INIT_SUCCESS, REPORTS_ACCT_INIT_FAIL
  , DOC_ACCT_INIT_LOADING, DOC_ACCT_INIT_SUCCESS, DOC_ACCT_INIT_FAIL
  , REPORTS_PARAM_INIT_LOADING, REPORTS_PARAM_INIT_SUCCESS, REPORTS_PARAM_INIT_FAIL
  , REPORTS_SPECIAL_INIT_LOADING, REPORTS_SPECIAL_INIT_SUCCESS, REPORTS_SPECIAL_INIT_FAIL
  , REPORTS_CUSTOM_1_INIT_LOADING, REPORTS_CUSTOM_1_INIT_SUCCESS, REPORTS_CUSTOM_1_INIT_FAIL
  , REPORTS_CUSTOM_2_INIT_LOADING, REPORTS_CUSTOM_2_INIT_SUCCESS, REPORTS_CUSTOM_2_INIT_FAIL
  , REPORTS_TREATY_INIT_LOADING, REPORTS_TREATY_INIT_SUCCESS, REPORTS_TREATY_INIT_FAIL
  , REPORTS_EXTRA_INIT_LOADING, REPORTS_EXTRA_INIT_SUCCESS, REPORTS_EXTRA_INIT_FAIL } from '@/store/types'

const state = {
  init: 0,
  initErr: [],
  menu: {},
  agencyReports: {
    init: 0,
    initErr: [],
    menu: {}
  },
  uwReports: {
    init: 0,
    initErr: [],
    menu: {},
    IPR: {
      sortOrderList: []
    }
  },
  acctReports: {
    init: 0,
    initErr: [],
    menu: {}
  },
  accountReports: {
    init: 0,
    initErr: [],
    menu: {}
  },
  riReports: {
    init: 0,
    initErr: [],
    menu: {}
  },
  rptHistoryList: {
    init: 0,
    menu: {},
    jobs: [],
    loadingNewRptHistory: false,
    hasNext: true,
    lastId: 0
  },
  favRptHistoryList: {
    init: 0,
    menu: {},
    jobs: [],
    loadingNewRptHistory: false,
    hasNext: true,
    lastId: 0
  },
  scheduleReports: {
    init: 0,
    initErr: [],
    menu: {}
  },
  claimReports: {
    init: 0,
    initErr: [],
    menu: {}
  },
  paramReports: {
    init: 0,
    initErr: [],
    menu: {}
  },
  specialReports: {
    init: 0,
    initErr: [],
    menu: {}
  },
  custom1Reports: {
    init: 0,
    initErr: [],
    menu: {}
  },
  custom2Reports: {
    init: 0,
    initErr: [],
    menu: {}
  },
  ttyReports: {
    init: 0,
    initErr: [],
    menu: {}
  },
  extraReports: {
    init: 0,
    initErr: [],
    menu: {}
  }
}

const getters = {
}

const mutations = {
  [REPORTS_INIT_LOADING](state) {
    state.init = 0
    state.initErr = []
    state.menu = {}
  },
  [REPORTS_INIT_SUCCESS](state, data) {
    state.init = 1
    state.initErr = []
    state.menu = data.menu
  },
  [REPORTS_INIT_FAIL](state, error) {
    state.init = 2
    state.initErr = error
    state.menu = {}
  },
  [REPORTS_AGENCY_INIT_LOADING](state) {
    state.agencyReports.init = 0
    state.agencyReports.initErr = []
    state.agencyReports.menu = {}
  },
  [REPORTS_AGENCY_INIT_SUCCESS](state, data) {
    state.agencyReports.init = 1
    state.agencyReports.initErr = []
    state.agencyReports.menu = data.menu
  },
  [REPORTS_AGENCY_INIT_FAIL](state, error) {
    state.agencyReports.init = 2
    state.agencyReports.initErr = error
    state.agencyReports.menu = {}
  },
  [REPORTS_HISTORY_INIT_LOADING](state) {
    state.rptHistoryList.init = 0
  },
  [REPORTS_HISTORY_INIT_SUCCESS](state, data) {
    state.rptHistoryList.init = 1
    state.rptHistoryList.menu = data.menu
    state.rptHistoryList.jobs = data.data.jobList

    if (data.data.jobList && data.data.jobList.length > 0) {
      state.rptHistoryList.hasNext = true
      state.rptHistoryList.lastId = data.data.jobList[data.data.jobList.length - 1].id
    } else {
      state.rptHistoryList.hasNext = false
      state.rptHistoryList.lastId = 0
    }
  },
  [REPORTS_HISTORY_INIT_FAIL](state) {
    state.rptHistoryList.init = 2
  },
  [REPORTS_HISTORY_FAVOURITE_INIT_LOADING](state) {
    state.favRptHistoryList.init = 0
  },
  [REPORTS_HISTORY_FAVOURITE_INIT_SUCCESS](state, data) {
    state.favRptHistoryList.init = 1
    state.favRptHistoryList.menu = data.menu
    state.favRptHistoryList.jobs = data.data.jobList

    if (data.data.jobList && data.data.jobList.length > 0) {
      state.favRptHistoryList.hasNext = true
      state.favRptHistoryList.lastId = data.data.jobList[data.data.jobList.length - 1].id
    } else {
      state.favRptHistoryList.hasNext = false
      state.favRptHistoryList.lastId = 0
    }
  },
  [REPORTS_HISTORY_FAVOURITE_INIT_FAIL](state) {
    state.favRptHistoryList.init = 2
  },
  [REPORTS_HISTORY_LOADMORE_LOADING](state) {
    state.rptHistoryList.loadingNewRptHistory = true
  },
  [REPORTS_HISTORY_LOADMORE_SUCCESS](state, data) {
    // Reload the menu (the next link)
    state.rptHistoryList.menu = data.menu

    if (data.data.jobList && data.data.jobList.length > 0) {
      // Append new notifications
      state.rptHistoryList.jobs.push.apply(state.rptHistoryList.jobs, data.data.jobList)
      state.rptHistoryList.hasNext = true
      state.rptHistoryList.lastId = data.data.jobList[data.data.jobList.length - 1].id
    } else {
      state.rptHistoryList.hasNext = false
    }

    state.rptHistoryList.loadingNewRptHistory = false
  },
  [REPORTS_HISTORY_LOADMORE_FAIL](state) {
    state.rptHistoryList.loadingNewRptHistory = false
  },
  [REPORTS_HISTORY_UPDATE](state, data) {
    state.rptHistoryList.jobs.map((item) => {
      if (item.id === data.id) {
        item.favourite = data.favourite
        if (data.favourite === true) {
          state.favRptHistoryList.jobs.unshift(item)
        } else {
          const index = state.favRptHistoryList.jobs.findIndex(a => a.id === data.id)
          state.favRptHistoryList.jobs.splice(index, 1)
        }
      }
    })
  },
  [REPORTS_HISTORY_FAVOURITE_UPDATE](state, data) {
    state.favRptHistoryList.jobs.map((item) => {
      if (item.id === data.id) {
        item.favourite = data.favourite
        if (!data.favourite) {
          const index = state.favRptHistoryList.jobs.findIndex(a => a.id === data.id)
          state.favRptHistoryList.jobs.splice(index, 1)
        }
      }
    })
    state.rptHistoryList.jobs.map((item) => {
      if (item.id === data.id) {
        item.favourite = data.favourite
      }
    })
  },
  [REPORTS_UW_INIT_LOADING](state) {
    state.uwReports.init = 0
    state.uwReports.initErr = []
    state.uwReports.menu = {}
  },
  [REPORTS_UW_INIT_SUCCESS](state, data) {
    state.uwReports.init = 1
    state.uwReports.initErr = []
    state.uwReports.menu = data.menu
  },
  [REPORTS_UW_INIT_FAIL](state, error) {
    state.uwReports.init = 2
    state.uwReports.initErr = error
    state.uwReports.menu = {}
  },
  [REPORTS_FIRESCHEDULE_INIT_LOADING](state) {
    state.scheduleReports.init = 0
    state.scheduleReports.initErr = []
    state.scheduleReports.menu = {}
  },
  [REPORTS_FIRESCHEDULE_INIT_SUCCESS](state, data) {
    state.scheduleReports.init = 1
    state.scheduleReports.initErr = []
    state.scheduleReports.menu = data.menu
  },
  [REPORTS_FIRESCHEDULE_INIT_FAIL](state, error) {
    state.scheduleReports.init = 2
    state.scheduleReports.initErr = error
    state.scheduleReports.menu = {}
  },
  [REPORTS_RI_INIT_LOADING](state) {
    state.riReports.init = 0
    state.riReports.initErr = []
    state.riReports.menu = {}
  },
  [REPORTS_RI_INIT_SUCCESS](state, data) {
    state.riReports.init = 1
    state.riReports.initErr = []
    state.riReports.menu = data.menu
  },
  [REPORTS_RI_INIT_FAIL](state, error) {
    state.riReports.init = 2
    state.riReports.initErr = error
    state.riReports.menu = {}
  },
  [REPORTS_CLAIM_INIT_LOADING](state) {
    state.claimReports.init = 0
    state.claimReports.initErr = []
    state.claimReports.menu = {}
  },
  [REPORTS_CLAIM_INIT_SUCCESS](state, data) {
    state.claimReports.init = 1
    state.claimReports.initErr = []
    state.claimReports.menu = data.menu
  },
  [REPORTS_CLAIM_INIT_FAIL](state, error) {
    state.claimReports.init = 2
    state.claimReports.initErr = error
    state.claimReports.menu = {}
  },
  [DOC_ACCT_INIT_LOADING](state) {
    state.acctReports.init = 0
    state.acctReports.initErr = []
    state.acctReports.menu = {}
  },
  [DOC_ACCT_INIT_SUCCESS](state, data) {
    state.acctReports.init = 1
    state.acctReports.initErr = []
    state.acctReports.menu = data.menu
  },
  [DOC_ACCT_INIT_FAIL](state, error) {
    state.acctReports.init = 2
    state.acctReports.initErr = error
    state.acctReports.menu = {}
  },
  [REPORTS_ACCT_INIT_LOADING](state) {
    state.accountReports.init = 0
    state.accountReports.initErr = []
    state.accountReports.menu = {}
  },
  [REPORTS_ACCT_INIT_SUCCESS](state, data) {
    state.accountReports.init = 1
    state.accountReports.initErr = []
    state.accountReports.menu = data.menu
  },
  [REPORTS_ACCT_INIT_FAIL](state, error) {
    state.accountReports.init = 2
    state.accountReports.initErr = error
    state.accountReports.menu = {}
  },
  [REPORTS_PARAM_INIT_LOADING](state) {
    state.paramReports.init = 0
    state.paramReports.initErr = []
    state.paramReports.menu = {}
  },
  [REPORTS_PARAM_INIT_SUCCESS](state, data) {
    state.paramReports.init = 1
    state.paramReports.initErr = []
    state.paramReports.menu = data.menu
  },
  [REPORTS_PARAM_INIT_FAIL](state, error) {
    state.paramReports.init = 2
    state.paramReports.initErr = error
    state.paramReports.menu = {}
  },
  [REPORTS_SPECIAL_INIT_LOADING](state) {
    state.specialReports.init = 0
    state.specialReports.initErr = []
    state.specialReports.menu = {}
  },
  [REPORTS_SPECIAL_INIT_SUCCESS](state, data) {
    state.specialReports.init = 1
    state.specialReports.initErr = []
    state.specialReports.menu = data.menu
  },
  [REPORTS_SPECIAL_INIT_FAIL](state, error) {
    state.specialReports.init = 2
    state.specialReports.initErr = error
    state.specialReports.menu = {}
  },
  [REPORTS_CUSTOM_1_INIT_LOADING](state) {
    state.custom1Reports.init = 0
    state.custom1Reports.initErr = []
    state.custom1Reports.menu = {}
  },
  [REPORTS_CUSTOM_1_INIT_SUCCESS](state, data) {
    state.custom1Reports.init = 1
    state.custom1Reports.initErr = []
    state.custom1Reports.menu = data.menu
  },
  [REPORTS_CUSTOM_1_INIT_FAIL](state, error) {
    state.custom1Reports.init = 2
    state.custom1Reports.initErr = error
    state.custom1Reports.menu = {}
  },
  [REPORTS_CUSTOM_2_INIT_LOADING](state) {
    state.custom2Reports.init = 0
    state.custom2Reports.initErr = []
    state.custom2Reports.menu = {}
  },
  [REPORTS_CUSTOM_2_INIT_SUCCESS](state, data) {
    state.custom2Reports.init = 1
    state.custom2Reports.initErr = []
    state.custom2Reports.menu = data.menu
  },
  [REPORTS_CUSTOM_2_INIT_FAIL](state, error) {
    state.custom2Reports.init = 2
    state.custom2Reports.initErr = error
    state.custom2Reports.menu = {}
  },
  [REPORTS_TREATY_INIT_LOADING](state) {
    state.ttyReports.init = 0
    state.ttyReports.initErr = []
    state.ttyReports.menu = {}
  },
  [REPORTS_TREATY_INIT_SUCCESS](state, data) {
    state.ttyReports.init = 1
    state.ttyReports.initErr = []
    state.ttyReports.menu = data.menu
  },
  [REPORTS_TREATY_INIT_FAIL](state, error) {
    state.ttyReports.init = 2
    state.ttyReports.initErr = error
    state.ttyReports.menu = {}
  },
  [REPORTS_EXTRA_INIT_LOADING](state) {
    state.extraReports.init = 0
    state.extraReports.initErr = []
    state.extraReports.menu = {}
  },
  [REPORTS_EXTRA_INIT_SUCCESS](state, data) {
    state.extraReports.init = 1
    state.extraReports.initErr = []
    state.extraReports.menu = data.menu
  },
  [REPORTS_EXTRA_INIT_FAIL](state, error) {
    state.extraReports.init = 2
    state.extraReports.initErr = error
    state.extraReports.menu = {}
  }
}

const actions = {
  async reportsInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.reports
    commit(REPORTS_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(REPORTS_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(REPORTS_INIT_FAIL, extractMessages(error))
    }
  },
  async agencyReportsInit({ commit, state }) {
    const apiUrl = state.menu.agencyReports
    commit(REPORTS_AGENCY_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(REPORTS_AGENCY_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(REPORTS_AGENCY_INIT_FAIL, extractMessages(error))
    }
  },
  async scheduleReportsInit({ commit, state }) {
    const apiUrl = state.menu.scheduleReports
    commit(REPORTS_FIRESCHEDULE_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu
      }
      commit(REPORTS_FIRESCHEDULE_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(REPORTS_FIRESCHEDULE_INIT_FAIL, extractMessages(error))
    }
  },
  async uwReportsInit({ commit, state }) {
    const apiUrl = state.menu.uwReports
    commit(REPORTS_UW_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu
      }
      commit(REPORTS_UW_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(REPORTS_UW_INIT_FAIL, extractMessages(error))
    }
  },
  async riReportsInit({ commit, state }) {
    const apiUrl = state.menu.RIReports
    commit(REPORTS_RI_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu
      }
      commit(REPORTS_RI_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(REPORTS_RI_INIT_FAIL, extractMessages(error))
    }
  },
  async claimReportsInit({ commit, state }) {
    const apiUrl = state.menu.claimReports
    commit(REPORTS_CLAIM_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu
      }
      commit(REPORTS_CLAIM_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(REPORTS_CLAIM_INIT_FAIL, extractMessages(error))
    }
  },
  async acctReportsInit({ commit, state }) {
    const apiUrl = state.menu.acctDocuments
    commit(DOC_ACCT_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu
      }
      commit(DOC_ACCT_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(DOC_ACCT_INIT_FAIL, extractMessages(error))
    }
  },
  async accountReportsInit({ commit, state }) {
    const apiUrl = state.menu.acctReports
    commit(REPORTS_ACCT_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu
      }
      commit(REPORTS_ACCT_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(REPORTS_ACCT_INIT_FAIL, extractMessages(error))
    }
  },
  async paramReportsInit({ commit, state }) {
    const apiUrl = state.menu.paramReports
    commit(REPORTS_PARAM_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu
      }
      commit(REPORTS_PARAM_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(REPORTS_PARAM_INIT_FAIL, extractMessages(error))
    }
  },
  async specialReportsInit({ commit, state }) {
    const apiUrl = state.menu.specialReports
    commit(REPORTS_SPECIAL_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu
      }
      commit(REPORTS_SPECIAL_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(REPORTS_SPECIAL_INIT_FAIL, extractMessages(error))
    }
  },
  async custom1ReportsInit({ commit, state }) {
    const apiUrl = state.menu.custom1Reports
    commit(REPORTS_CUSTOM_1_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(REPORTS_CUSTOM_1_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(REPORTS_CUSTOM_1_INIT_FAIL, extractMessages(error))
    }
  },
  async custom2ReportsInit({ commit, state }) {
    const apiUrl = state.menu.custom2Reports
    commit(REPORTS_CUSTOM_2_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(REPORTS_CUSTOM_2_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(REPORTS_CUSTOM_2_INIT_FAIL, extractMessages(error))
    }
  },
  async ttyReportsInit({ commit, state }) {
    const apiUrl = state.menu.ttyReports
    commit(REPORTS_TREATY_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(REPORTS_TREATY_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(REPORTS_TREATY_INIT_FAIL, extractMessages(error))
    }
  },
  async extraReportsInit({ commit, state }) {
    const apiUrl = state.menu.extraReports
    commit(REPORTS_EXTRA_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(REPORTS_EXTRA_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(REPORTS_EXTRA_INIT_FAIL, extractMessages(error))
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
